import React, { createContext, useReducer, useMemo } from 'react';
import combinedReducer, { initState, State } from './combinedReducer';
import actionsFactory, { CombinedActions } from './actionsFactory';
import PusherHandler from './PusherHandler';

type ContextType = {
  actions: CombinedActions;
} & State;

const initContext = {
  ...initState,
  actions: actionsFactory(() => {}),
};

const UserEnvironmentContext = createContext<ContextType>(initContext);

const UserEnvironmentContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(combinedReducer, initState);
  const actions = useMemo(() => actionsFactory(dispatch), [dispatch]);

  const contextValue = {
    ...state,
    actions
  };

  return (
    <>
      <PusherHandler dispatch={dispatch} actions={actions} state={state} />
      <UserEnvironmentContext.Provider value={contextValue}>
        {children}
      </UserEnvironmentContext.Provider>
    </>
  );
};

export { UserEnvironmentContext, UserEnvironmentContextProvider };
